<template>
  <div class="main">
    <!-- 介绍 -->
    <div class="recommend">
      <div class="title">{{ data[index].title }}</div>
      <div class="line"></div>
      <div class="desc">
        {{ data[index].desc }}
      </div>
      <div class="background"></div>
    </div>
    <div class="tag">
      <div>
        <div v-for="item of data[index].tagList" :key="item">{{ item }}</div>
      </div>
      <img :src="data[index].cover" alt="" />
    </div>
    <!-- 方案应用 -->
    <!-- <div class="constitute">
      <div>
        <div class="title">方案构成</div>
        <div class="content">
          <div class="list" v-for="item of list" :key="item">
            <img src="" alt="" />
            <div class="headline">硬件</div>
            <div>HARDWARE</div>
            <div class="desc">内容多平台支持： 头戴一体机、暴风、大朋</div>
          </div>
        </div>
        <div class="more">more</div>
      </div>
    </div> -->
    <!-- 线下场景 -->
    <div class="plan">
      <div class="title">应用领域</div>
      <div class="content">
        <div class="list" v-for="item of data[index].constitute" :key="item">
          <img :src="item.img" alt="" />
          <div class="desc">{{item.title}}</div>
        </div>
      </div>
    </div>
    <!-- 客户案例 -->
    <!-- <div class="case">
      <div>
        <div class="title">行业案例</div>
        <div class="content">
          <div class="hasImg">
            <img src="" alt="" />
            <span class="headline">西安科技大学</span>
            <span class="headline">国家级虚拟仿真实验项目</span>
            <span class="desc"
              >CAVE硬件环境和煤矿开采仿真教学课件，根据教学需要</span
            >
          </div>
          <div class="hasImg">
            <img src="" alt="" />
            <span class="headline">西安科技大学</span>
            <span class="headline">国家级虚拟仿真实验项目</span>
            <span class="desc"
              >CAVE硬件环境和煤矿开采仿真教学课件，根据教学需要</span
            >
          </div>
          <div class="hasImg">
            <img src="" alt="" />
            <span class="headline">西安科技大学</span>
            <span class="headline">国家级虚拟仿真实验项目</span>
            <span class="desc"
              >CAVE硬件环境和煤矿开采仿真教学课件，根据教学需要</span
            >
          </div>
        </div>
        <div class="more">
          <span>查看更多案例</span>
          <img src="" alt="" />
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [1, 2, 3, 4],
      data: [
        {
          title: '燧光MR',
          desc: '是⼀款国内⾃主研发 MR 交互系统，也是整个 MR 全息实训教育场景的核⼼设备。',
          tagList: ['多人协作，多⼈定位，共享同⼀空间，实时协作','独创定位跟踪交互系统','超⼤视场⻆，视野⼴阔，画⾯完整'],
          cover: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/6.png',
          constitute: [{
            title:'军用机械',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/7.png'
          },{
            title:'建筑机械',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/8.png'
          },{
            title:'农用机械',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/9.png'
          },{
            title:'矿山机械',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/10.png'
          }]
        },
        {
          title: '未来感知',
          desc: '桌面级VR一体机，基于工业稳定的OPS电脑工作平台，采用120Hz 1080p 高清27寸主动式3D立体显示系统，结合虚拟现实技术（VR）和增强现实技术（AR）,提供沉浸式、交互式仿真体验',
          tagList: ['27寸主动式3D立体全高清显示系统','一体化设计','支持双光学交互笔同时操作；','高性能插拔式OPS电脑主机'],
          cover: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/11.png',
          constitute: [{
            title:'k12教学',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/12.png'
          },{
            title:'机械职教',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/13.png'
          },{
            title:'医用教学',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/14.png'
          },{
            title:'娱乐领域',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/15.png'
          }]
        },
        {
          title: 'CAVE',
          desc: 'CAVE系统是一种设计独特的显示环境，由于CAVE显示环境能覆盖的参与者全部视野,所以能提供给使用者一种前所未有的沉浸感，达到身临其境的体验和触手可及的交互',
          tagList: ['27寸主动式3D立体全高清显示系统','一体化设计','支持双光学交互笔同时操作；','高性能插拔式OPS电脑主机'],
          cover: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/6.jpg',
          constitute: [{
            title:'k12教学',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/10.png'
          },{
            title:'机械职教',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/11.png'
          },{
            title:'医用教学',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/12.png'
          },{
            title:'娱乐领域',
            img:'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/13.png'
          }]
        }
      ],
      index: 0
    };
  },
  created() {
    this.index = this.$route.query.id
  },
  watch: {
    $route(to, from) {
      if (from.name == to.name) {
        this.index = this.$route.query.id
      }
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  .recommend {
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/hardware/5.jpg);
    background-size: cover;
    width: 100%;
    height: 500px;
    text-align: center center;
    padding-top: 1px;
    position: relative;
    z-index: 1;
    .title {
      margin-top: 300px;
      font-size: 42px;
      color: #4d4d4d;
      line-height: 1;
      position: relative;
      z-index: 2;
      text-align: center;
    }
    .line {
      margin: 0 auto;
      margin-top: 25px;
      border-left: 71px solid #fdd917;
      border-right: 541px solid #c2bebe;
      height: 1px;
      width: 0px;
      position: relative;
      z-index: 2;
    }
    .desc {
      width: 938px;
      margin: 0 auto;
      margin-top: 12px;
      font-size: 24px;
      color: #1d1d1e;
      line-height: 36px;
      position: relative;
      z-index: 2;
    }
    .background{
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0)
      );
      z-index: 1;
    }
  }
  .tag {
    padding-top: 44px;
    padding-bottom: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    > div {
      width: 439px;
      min-height: 236px;
      background: #f27529;
      padding: 20px 42px 20px 71px;
      box-sizing: border-box;
      justify-content: center;
      display: flex;
      flex-direction: column;
      div{
        font-size: 20px;
        color: #ffffff;
        line-height: 1.5;
        margin-top: 4px;
      }
      position: relative;
      z-index: 1;
    }
    img {
      width: 804px;
      // height: 336px;
      margin-left: -42px;
      display: block;
    }
  }
  .plan {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    padding-top: 1px;
    padding-bottom: 100px;
    .title {
      font-size: 42px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.6);
      line-height: 63px;
      text-align: center;
      margin-top: 77px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      padding-bottom: 36px;
      margin-top: 30px;
      .list {
        // width: 241px;
        img {
          width: 241px;
          height: 241px;
          border-radius: 6px;
          margin: 0 auto;
        }
        .desc {
          text-align: center;
          font-size: 28px;
          font-weight: bold;
          color: #9fa1b4;
          line-height: 40px;
          margin-top: 20px;
        }
      }
    }
  }
  .constitute {
    background-image: url( ~@/assets/images/background.png);
    background-size: 100% 100%;
    > div {
      width: 1200px;
      height: 738px;
      margin: 0 auto;
      overflow: hidden;
      .title {
        text-align: center;
        margin-top: 161px;
        line-height: 1;
        font-size: 42px;
        font-weight: bold;
        color: #ffffff;
      }
      .content {
        display: flex;
        overflow: hidden;
        .list {
          width: 25%;
          height: 398px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 0 45px;
          box-sizing: border-box;
          > img {
            width: 87px;
            height: 87px;
            display: block;
          }
          .headline {
            font-size: 36px;
            font-weight: 500;
            color: #ffffff;
            line-height: 1;
            margin-top: 27px;
            text-align: center;
            & + div {
              font-size: 18px;
              font-weight: 400;
              color: #ffffff;
              line-height: 1;
              margin-top: 10px;
            }
          }
          .desc {
            font-size: 18px;
            font-weight: 400;
            color: #ffffff;
            line-height: 1;
            margin-top: 24px;
          }
          &::after {
            content: "";
            width: 1px;
            height: 100%;
            position: absolute;
            top: 0;
            right: -1px;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0),
              #fff,
              rgba(255, 255, 255, 0.1)
            );
          }
        }
      }
      .more {
        width: 209px;
        height: 47px;
        border-radius: 24px;
        border: 1px solid #ffffff;
        margin: 0 auto;
        margin-top: 18px;
        text-align: center;
        line-height: 47px;
        font-size: 32px;
        font-weight: 300;
        color: #ffffff;
      }
    }
  }
  .case {
    width: 100%;
    background: #fff;
    > div {
      width: 1200px;
      height: 691px;
      margin: 0 auto;
      padding-top: 1px;
      .title {
        font-size: 42px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
        text-align: center;
        margin-top: 48px;
      }
      .content {
        width: 100%;
        display: flex;
        height: 391px;
        margin-top: 49px;
        .hasImg {
          width: 33.3%;
          height: 100%;
          box-sizing: border-box;
          border-right: 1px solid #dadada;
          padding: 0 30px;
          &:nth-child(3) {
            border: none;
          }
          img {
            width: 100%;
            height: 200px;
          }
          .headline{
            margin-top: 40px;
            line-height: 1;
            font-size: 28px;
            font-weight: bold;
            color: #9FA1B4;
            display: block;
            &:nth-of-type(2){
              margin-top: 10px;
            }
          }
          .desc{
            display: block;
            font-size: 18px;
            font-weight: 400;
            color: #9FA1B4;
            line-height: 24px;
            margin-top: 20px;
          }
        }
        .noImg {
          width: 33.3%;
          height: 100%;
          > div {
            width: 100%;
            padding: 15px;
            box-sizing: border-box;
            &:last-child {
              border-top: 1px solid #dadada;
            }
            .headline {
              font-size: 28px;
              font-weight: bold;
              color: #9fa1b4;
              line-height: 40px;
              min-height: 92px;
            }
            .desc {
              font-size: 18px;
              font-weight: 400;
              color: #9fa1b4;
              line-height: 24px;
              margin-top: 20px;
            }
          }
        }
      }
      .more {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        span {
          font-size: 24px;
          color: #9fa1b4;
          line-height: 1;
        }
        img {
          width: 22px;
          height: 18px;
        }
      }
    }
  }
}
</style>
